/**
 * Role choice on the sign-in form.
 *
 * The design has two joined buttons — Zadavatel / Řemeslník — and the primary
 * button's label follows the selection ("Přihlásit se → jako zadavatel").
 *
 * Progressive enhancement: the markup ships with a real radio group and a
 * server-rendered label, so the form works with JavaScript disabled. This only
 * removes the round trip.
 */
export function initRoleToggle(root = document) {
  const group = root.querySelector("[data-role-toggle]");
  if (!group) return;

  const options = Array.from(group.querySelectorAll("[data-role-option]"));
  const input = root.querySelector("[data-role-input]");
  const submitLabel = root.querySelector("[data-role-submit-label]");
  if (options.length === 0 || !input) return;

  function select(role) {
    options.forEach((option) => {
      const active = option.dataset.roleOption === role;
      option.setAttribute("aria-pressed", active ? "true" : "false");
    });
    input.value = role;

    if (submitLabel) {
      const chosen = options.find((option) => option.dataset.roleOption === role);
      // The suffix is rendered by the server for each role, so the copy stays in
      // the translation catalogue rather than being assembled in JavaScript.
      const suffix = chosen && chosen.dataset.roleSuffix;
      if (suffix) submitLabel.textContent = suffix;
    }
  }

  options.forEach((option) => {
    option.addEventListener("click", () => select(option.dataset.roleOption));
  });

  const preselected = options.find((option) => option.getAttribute("aria-pressed") === "true");
  if (preselected) select(preselected.dataset.roleOption);
}
